/* Chilldoze theme scripts (vanilla JS, no dependencies) */
(function () {
  'use strict';
  var T = window.ChilldozeTheme || { routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' }, templateName: '' };
  var doc = document;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('#Toast');
    if (!el) { el = doc.createElement('div'); el.id = 'Toast'; el.className = 'toast'; el.setAttribute('role', 'status'); doc.body.appendChild(el); }
    el.textContent = msg;
    el.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-show'); }, 3500);
  }

  /* ---------- cart drawer ---------- */
  function drawer() { return $('#CartDrawer'); }
  function openCart() {
    var d = drawer(), s = $('[data-cart-scrim]');
    if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    if (s) s.classList.add('is-open');
    doc.documentElement.style.overflow = 'hidden';
    var c = $('[data-cart-close]', d); if (c) c.focus();
  }
  function closeCart() {
    var d = drawer(), s = $('[data-cart-scrim]');
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (s) s.classList.remove('is-open');
    doc.documentElement.style.overflow = '';
  }
  function setBadge(n) {
    $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
  }
  function refreshCart() {
    return fetch(T.routes.root + '?sections=cart-drawer,mini-cart')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var next = $('#CartDrawerInner', parsed), cur = $('#CartDrawerInner');
          if (next && cur) {
            cur.replaceWith(next);
            var lbl = $('[data-cart-count-label]', next);
            if (lbl) setBadge(parseInt(lbl.textContent, 10) || 0);
          }
        }
        var miniHtml = data['mini-cart'];
        if (miniHtml) {
          var miniParsed = new DOMParser().parseFromString(miniHtml, 'text/html');
          var miniNext = $('#MiniCartInner', miniParsed), miniCur = $('#MiniCartInner');
          if (miniNext && miniCur) miniCur.replaceWith(miniNext);
          var miniRoot = $('[data-mini-cart]');
          if (miniRoot) miniRoot.classList.remove('is-dismissed');
        }
      });
  }
  function addToCart(formData) {
    return fetch(T.routes.cartAdd + '.js', { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
        return refreshCart().then(function () { if (T.templateName === 'cart') { window.location.reload(); } else { openCart(); } });
      });
  }
  function changeLine(line, quantity) {
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(refreshCart);
  }

  /* ---------- product page ---------- */
  function selectedOptions(root) {
    return $$('.opts', root).map(function (g) {
      var a = $('.opt.is-active', g); return a ? a.getAttribute('data-value') : null;
    });
  }
  function findVariant(root) {
    var holder = $('[data-variants]', root); if (!holder) return null;
    var variants; try { variants = JSON.parse(holder.textContent); } catch (e) { return null; }
    var sel = selectedOptions(root);
    return variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || null;
  }
  function swapVariant(root, variant) {
    var qty = $('[data-qty-input]', root); var q = qty ? qty.value : '1';
    var url = root.getAttribute('data-product-url') + '?variant=' + variant.id + '&section_id=' + root.getAttribute('data-section-id');
    return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var pairs = [['[data-buy]', '[data-buy]'], ['[data-gallery]', '[data-gallery]'], ['[data-sticky-bar]', '[data-sticky-bar]']];
      pairs.forEach(function (p) {
        var cur = $(p[0], root), nxt = $(p[1], parsed);
        if (cur && nxt) cur.innerHTML = nxt.innerHTML;
      });
      var nq = $('[data-qty-input]', root); if (nq) nq.value = q;
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', variant.id); history.replaceState({}, '', u.toString());
      }
    });
  }
  function onOptionClick(btn) {
    var root = btn.closest('[data-product-section]'); if (!root) return;
    $$('.opt', btn.parentNode).forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-pressed', 'false'); });
    btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true');
    var v = findVariant(root);
    var atc = $('[data-atc]', root), sticky = $('[data-sticky-atc]', root);
    if (v) { swapVariant(root, v); }
    else {
      [atc, sticky].forEach(function (b) { if (b) { b.disabled = true; b.textContent = 'Unavailable'; } });
    }
  }

  /* ---------- click delegation ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    var el;

    if ((el = t.closest('[data-cart-open]')) && T.templateName !== 'cart') { e.preventDefault(); refreshCart().then(openCart); return; }
    if (t.closest('[data-cart-close]') || t.closest('[data-cart-scrim]')) { closeCart(); return; }

    if ((el = t.closest('[data-quick-add]'))) {
      e.preventDefault();
      var fd = new FormData(); fd.append('id', el.getAttribute('data-variant-id')); fd.append('quantity', '1');
      el.disabled = true;
      addToCart(fd).catch(function (err) { toast(err.message); }).then(function () { el.disabled = false; });
      return;
    }
    if ((el = t.closest('[data-line-change]'))) {
      e.preventDefault(); el.disabled = true;
      changeLine(parseInt(el.getAttribute('data-line'), 10), parseInt(el.getAttribute('data-quantity'), 10));
      return;
    }

    if ((el = t.closest('[data-menu-toggle]'))) {
      var nav = $('#NavPill'); var open = nav.classList.toggle('is-open'); el.setAttribute('aria-expanded', open); return;
    }
    if ((el = t.closest('[data-nav-toggle]'))) {
      var item = el.closest('.nav-item'); var o = item.classList.toggle('is-open'); el.setAttribute('aria-expanded', o); return;
    }
    if (!t.closest('.nav-item')) { $$('.nav-item.is-open').forEach(function (i) { i.classList.remove('is-open'); }); }

    if ((el = t.closest('[data-acc-head]'))) {
      var itm = el.closest('.acc-item'); var isOpen = itm.classList.toggle('is-open'); el.setAttribute('aria-expanded', isOpen); return;
    }

    if ((el = t.closest('[data-tab]'))) {
      var wrap = el.closest('[data-tabs]'); var id = el.getAttribute('data-tab');
      $$('[data-tab]', wrap).forEach(function (b) { var on = b === el; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
      $$('[data-tab-panel]', wrap).forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== id; });
      return;
    }
    if ((el = t.closest('[data-slide]'))) {
      var sl = $('[data-slider]', el.closest('.slider-wrap'));
      if (sl) sl.scrollBy({ left: parseInt(el.getAttribute('data-slide'), 10) * Math.max(320, sl.clientWidth * 0.8), behavior: 'smooth' });
      return;
    }

    if ((el = t.closest('.opt')) && el.closest('[data-buy]')) { onOptionClick(el); return; }
    if ((el = t.closest('[data-qty-step]'))) {
      var inp = $('[data-qty-input]', el.parentNode);
      var val = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(el.getAttribute('data-qty-step'), 10));
      inp.value = val; return;
    }
    if ((el = t.closest('[data-thumb]'))) {
      var g = el.closest('[data-gallery]'); var img = $('.gallery-main img', g);
      if (img) { img.src = el.getAttribute('data-src'); img.removeAttribute('srcset'); img.alt = el.getAttribute('data-alt'); }
      $$('[data-thumb]', g).forEach(function (b) { b.classList.toggle('is-active', b === el); });
      return;
    }
    if ((el = t.closest('[data-sticky-atc]'))) {
      var f = $('[data-product-form]'); if (f && f.requestSubmit) f.requestSubmit(); return;
    }
    if ((el = t.closest('[data-toggle-recover]'))) {
      e.preventDefault();
      var showRecover = el.getAttribute('href') === '#recover';
      $('#recover').hidden = !showRecover; $('#login').hidden = showRecover; return;
    }
  });

  doc.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('[data-atc]', form), err = $('[data-atc-error]', form);
    if (btn && btn.disabled) return;
    if (err) err.hidden = true;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    addToCart(new FormData(form)).catch(function (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; } else { toast(ex.message); }
    }).then(function () {
      var b = $('[data-atc]'); if (b) { b.disabled = false; b.textContent = label; }
    });
  });

  doc.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-sort-select]');
    if (s) { var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString(); }
  });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); } });

  /* ---------- sticky add-to-cart bar ---------- */
  function onScroll() {
    var b = $('[data-sticky-bar]'); if (!b) return;
    b.classList.toggle('is-show', window.scrollY > 640);
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- product recommendations ---------- */
  var rec = $('[data-recommendations]');
  if (rec && rec.getAttribute('data-url')) {
    fetch(rec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var src = $('[data-recommendations]', parsed);
      if (src && src.innerHTML.trim()) rec.innerHTML = src.innerHTML;
    }).catch(function () {});
  }

  /* ---------- login page ---------- */
  if (window.location.hash === '#recover' && $('#recover') && $('#login')) { $('#recover').hidden = false; $('#login').hidden = true; }
})();
